// import React from "react";
// import { Link } from "react-router-dom";
// import image1 from "../../assets/images/BestSellers/kids/PC-C-2-Desktop-Kids-08May2025.png";
// import image2 from "../../assets/images/BestSellers/kids/PC-C-3-Desktop-Kids-08May2025.png";
// import image3 from "../../assets/images/BestSellers/kids/PC-C-4-Desktop-Kids-08May2025.png";
// import image4 from "../../assets/images/BestSellers/kids/PC-C-5-Desktop-Kids-08May2025.png";
// import image5 from "../../assets/images/BestSellers/kids/PC-C-6-Desktop-Kids-08May2025.png";
// import image6 from "../../assets/images/BestSellers/kids/PC-C-6-Desktop-Kids-08May2025.png";

// /**
//  * Replace image paths with real assets in `public/images/kids/...`
//  * Example: /images/kids/0-2.jpg
//  */
// const ageGroups = [
//   { id: "0-2", label: "0-2 Years", image: image1 },
//   { id: "3-5", label: "3-5 Years", image: image2 },
//   { id: "6-8", label: "6-8 Years", image: image3 },
//   { id: "9-11", label: "9-11 Years", image: image4 },
//   { id: "12-14", label: "12-14 Years", image: image5 },
//   { id: "15+", label: "15+ Years", image: image6 },
// ];

// const KidsAgeGroups = ({ basePath = "kids" }) => {
//   return (
//     <section className="w-full py-10 px-4 md:px-8">
//       <h3 className="text-center text-xl md:text-2xl font-semibold mb-8">
//         Kids
//       </h3>

//       <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
//         {ageGroups.map((g) => (
//           <Link
//             key={g.id}
//             to={`${basePath}/${g.id}`}
//             className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition flex flex-col"
//           >
//             {/* IMAGE – NO HEIGHT, NO CROP */}
//             <div className="w-full bg-white flex items-center justify-center p-2">
//               <img
//                 src={g.image}
//                 alt={g.label}
//                 className="
//                   w-full
//                   h-auto
//                   object-contain
//                 "
//               />
//             </div>

//             {/* LABEL – ALWAYS STICKS BOTTOM */}
//             <div className="bg-[#dff07a] text-center py-3 text-sm md:text-base font-semibold mt-auto">
//               {g.label}
//             </div>
//           </Link>
//         ))}
//       </div>
//     </section>
//   );
// };



// export default KidsAgeGroups;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

const KidsAgeGroups = ({ basePath = "kids" }) => {
  const [ageGroups, setAgeGroups] = useState([]);

  useEffect(() => {
    const fetchAgeGroups = async () => {
      const res = await api({
        method: SummaryApi.getKidsAgeGroups.method,
        url: SummaryApi.getKidsAgeGroups.url
      });

      if (res.data.success) {
        setAgeGroups(res.data.ageGroups);
      }
    };

    fetchAgeGroups();
  }, []);

  if (!ageGroups.length) return null;

  return (
    <section className="w-full py-6 px-4 bg-white">
  <h2 className="text-center text-lg md:text-xl font-semibold mb-6 ">
    Kids
  </h2>

  <div className="
    grid
    grid-cols-2
    md:grid-cols-3
    gap-4
    md:gap-6
    max-w-6xl
    mx-auto
    items-stretch
  ">
    {ageGroups.map((g) => (
      <Link
        key={g.ageGroup}
        to={`/${basePath}/${g.slug}`}
        className="
          bg-white
          rounded-md
          border
          border-gray-200
          overflow-hidden
          flex
          flex-col
          h-full
        "
      >
        {/* IMAGE WRAPPER (FIXED HEIGHT) */}
        <div
          className="
            w-full
            h-[220px]
            md:h-[260px]
            bg-white
            flex
            items-center
            justify-center
            p-3
          "
        >
          <img
            src={g.previewImage}
            alt={g.ageGroup}
            className="max-h-full max-w-full object-contain"
          />
        </div>

        {/* LABEL – ALWAYS BOTTOM */}
        <div
          className="
            bg-lime-200
            text-center
            py-2
            text-xs
            md:text-sm
            font-medium
            mt-auto
          "
        >
          {g.ageGroup}
        </div>
      </Link>
    ))}
  </div>
</section>

  );
};

export default KidsAgeGroups;
